import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  TableRow,
  Checkbox,
  TableCell,
  Pagination,
  WrapperFlex,
} from '@unimed-fesp/components';

import { Creators as ListaActions } from '../../../store/ducks/lista';

import Skeleton from '../../atoms/Skeleton';
import EmptyContent from '../../molecules/EmptyContent';

import TipoBeneficiarioEnum from '../../../enums/TipoBeneficiarioEnum';

const TableBodyBeneficiario = ({
  readOnly,
  paginationParams,
  setPaginationParams,
  loadingSalvarBeneficiario,
}) => {
  const dispatch = useDispatch();
  const lista = useSelector((state) => state.lista);
  const { listaGrupoFamiliar, listaInativos } = useSelector(
    (state) => state.lista.response
  );

  const checkBeneficiario = useCallback(
    (beneficiario) => {
      dispatch(
        ListaActions.checkBenefiarioInativos(beneficiario.idBeneficiario)
      );
    },
    [dispatch]
  );

  const handleChangePage = useCallback(
    (paramsPgs) => {
      setPaginationParams({
        ...paramsPgs,
      });
    },
    [setPaginationParams]
  );

  const handlePageChangeKeyDown = useCallback(
    (e) => {
      if (e.keyCode === 13 && paginationParams.pageNumber !== '')
        setPaginationParams({
          ...paginationParams,
        });
    },
    [paginationParams, setPaginationParams]
  );

  // #region Loading
  if (loadingSalvarBeneficiario || lista.loading)
    return (
      <TableRow>
        <TableCell colSpan={6}>
          <WrapperFlex column>
            <Skeleton height="80px" marginUpDown="10" />
            <Skeleton height="40px" marginUpDown="10" />
            <Skeleton height="20px" marginUpDown="20" />
          </WrapperFlex>
        </TableCell>
      </TableRow>
    );
  // #endregion

  // #region EmptyContent
  if (!listaGrupoFamiliar || listaGrupoFamiliar.length <= 0)
    return (
      <TableRow>
        <TableCell colSpan={6}>
          <EmptyContent />
        </TableCell>
      </TableRow>
    );
  // #endregion

  const listaGrupoFamiliarPag = [...listaGrupoFamiliar].splice(
    (paginationParams.pageNumber - 1) * paginationParams.pageSize,
    paginationParams.pageSize
  );

  return (
    <>
      {listaGrupoFamiliarPag.map((beneficiario) => (
        <TableRow
          key={beneficiario.idBeneficiario}
          onClick={() => {
            if (readOnly) return;

            if (
              beneficiario.grau ===
              TipoBeneficiarioEnum.returnNameForNameFormatted.Dependente
            ) {
              checkBeneficiario(beneficiario);
            }
          }}
          isClickable={
            readOnly
              ? false
              : beneficiario.grau ===
                TipoBeneficiarioEnum.returnNameForNameFormatted.Dependente
          }
        >
          <TableCell minWidth={20} maxWidth={20}>
            <Checkbox
              height={18}
              width={18}
              checked={beneficiario.isChecked}
              disabled={
                beneficiario.grau !==
                TipoBeneficiarioEnum.returnNameForNameFormatted.Dependente
              }
            />
          </TableCell>
          <TableCell maxWidth={350} minWidth={350}>
            {beneficiario.nome ? beneficiario.nome : '-'}
          </TableCell>
          <TableCell maxWidth={150} minWidth={150}>
            {beneficiario.grau ? beneficiario.grau : '-'}
          </TableCell>
          <TableCell maxWidth={120} minWidth={120}>
            {beneficiario.modalidadeEntrada
              ? beneficiario.modalidadeEntrada
              : '-'}
          </TableCell>
          <TableCell maxWidth={150} minWidth={150}>
            {beneficiario.termo ? beneficiario.termo : '-'}
          </TableCell>
          <TableCell maxWidth={150} minWidth={150}>
            {listaInativos?.nrCodigoModalidade}
          </TableCell>
        </TableRow>
      ))}
      <TableRow>
        <TableCell colSpan={7}>
          <Pagination
            total={listaGrupoFamiliar.length}
            paginationParams={paginationParams}
            setPaginationParams={setPaginationParams}
            handlePageChangeKeyDown={handlePageChangeKeyDown}
            callbackChangePage={handleChangePage}
          />
        </TableCell>
      </TableRow>
    </>
  );
};

export default TableBodyBeneficiario;
